module.exports = __webpack_public_path__ + "staticmedia/media/MasterCard-VisaCard.137a5ec3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/MasterCard-VisaCard.svg
// module id = 557
// module chunks = 0